export default __webpack_public_path__ + "static/media/add_icon_darkest.beb02c4c.svg";